import {formSettings, FormSettings} from '../../../bps/components/form/formSettings';

formSettings.checkboxIsSwitch = true;
formSettings.remainSignedIn = true;

export {formSettings, FormSettings};
